import { useOfflineMantencionBase } from 'hooks/useOfflineMantencionBase';
import { createContext, useContext } from 'react';

const OneMantencionContext = createContext(null);

export const OneMantencionProvider = ({ children }) => {
  const { data, isLoading, error, hasCalled, call } = useOfflineMantencionBase();
  return (
    <OneMantencionContext.Provider value={{ call, isLoading, error, hasCalled, data }}>
      {children}
    </OneMantencionContext.Provider>
  );
};

export const useOneMantencion = () => useContext(OneMantencionContext);
